'use client';

// Core
import { FC } from 'react';

// Global UI components
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';

// Local components
import { Header } from './header';
import { Social } from './social';
import { BackButton } from './back-button';
import { useTranslations } from '@/hooks/useTranslations';
import { motion } from 'framer-motion';

interface TCardWrapper {
  children: React.ReactNode;
  headerLabel?: string;
  backButtonLabel?: string;
  backButtonHref: string;
  showSocial?: boolean;
  title?: string;
}

export const CardWrapper: FC<TCardWrapper> = ({
  children,
  title,
  backButtonHref,
  backButtonLabel,
  headerLabel,
  showSocial,
}) => {
  const t = useTranslations('LoginForm');

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="w-full"
    >
      <Card className="w-full md:w-150 md:m-auto lg:w-112.5 border-0 shadow-none">
        {(headerLabel || title) && (
          <CardHeader>
            <Header title={title} label={headerLabel} />
          </CardHeader>
        )}

        <CardContent>{children}</CardContent>

        {showSocial && (
          <div>
            <div className="flex justify-center items-center gap-3 px-6 pb-6">
              <div className="flex-1 h-px bg-gray-400" />

              <div className="font-light text-sm">{t('orSignIn')}</div>

              <div className="flex-1 h-px bg-gray-400"></div>
            </div>

            <CardFooter>
              <Social />
            </CardFooter>
          </div>
        )}

        {backButtonLabel && (
          <CardFooter>
            <BackButton href={backButtonHref} label={backButtonLabel} />
          </CardFooter>
        )}
      </Card>
    </motion.div>
  );
};
